import React from 'react';

import BaseDetailScreen from '../../BaseDetailScreen';
import getDisclaimer from './getDisclaimer';


const Component = ({ view, backTo, backLabel }) => {
  const disclaimer = getDisclaimer(view);

  return (
    <BaseDetailScreen
      pageHeading={disclaimer.header}
      backTo={backTo}
      backLabel={backLabel}
    >
      { disclaimer.text() }
    </BaseDetailScreen>
  );
};

Component.displayName = 'DisclaimerViews';

export default Component;



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/DisclaimerViews/index.js